import React, {useState} from "react";
import { projects, topProjects } from "../data";
import "./Projects.css";
import codingLogo from "../assets/images/codeLogo.png";
import { Card } from "react-bootstrap";
import ProjectModal from "./ProjectModal";

function Projects() {
  const [show, setShow] = useState(false);
  const [projectData, setProjectData] = useState({});

  const renderCard = (project, index) => {
    return (
      <Card style={{ width: "18rem"}} key={index}>
        <Card.Img className="projectImg" style={{cursor: "pointer"}} onClick={()=> {
          setProjectData(project);
          setShow(true);
          }} variant="top" src={project.image} />
        <Card.Body>
          <Card.Title><a href={project.link} target="_blank" rel="noreferrer">{project.title}</a></Card.Title>
          <Card.Text>{project.description}</Card.Text>
        </Card.Body>
      </Card>
    );
  };

  return (
    <div id="projects" className="projects">
      <div className="favourites">
        <img id="codeLogo" src={codingLogo} alt="logo"></img>
        <h1>Some Things I’ve Built</h1>
        <p>
          This is a collection of applications that I have built to solidify my
          current knowledge as well as to learn more in the process.
        </p>
        <div className="projectDisplay">{topProjects.map((project,index) => {
              return renderCard(project, index)
            })}</div>
      </div>

      <div className="others">
        <img id="codeLogo" src={codingLogo} alt="logo"></img>
        <h1>Other Noteworthy Projects</h1>

        <div className="projectDisplay">
            {projects.map((project,index) => {
              return renderCard(project, index)
            })}
        </div>
      </div>

      <ProjectModal show={show} setShow={setShow} data={projectData}/>
      
    </div>
  );
}

export default Projects;

